import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";

// components
import Navbar from "../components/Navbars/Navbar";
import Footer from "../components/Footer/Footer";
import Sidebar from "../components/Sidebar/Sidebar";

// routes
import routes from "../routes.js";

// api
import usuario_api from "../api/usuario_api.js";

// helpers
import { showMessage } from "../helpers/message.js";
import { getSessionCookie } from '../helpers/cookies';

var ps;

class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: "black",
      activeColor: "info",
    };
    this.mainPanel = React.createRef();
  }
  componentDidMount() {
    var session = getSessionCookie();
    if (session == null)
      window.location.href = "/auth/login"
    if (session.expired)
    {
      showMessage("Aviso", "Sua sessão expirou. Realize o acesso novamente!", 'warning', function(){
        window.location.href = "/auth/login"
      });
    }

    this.getRoutes();
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      this.mainPanel.current.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }
  }
  handleActiveClick = (color) => {
    this.setState({ activeColor: color });
  };
  handleBgClick = (color) => {
    this.setState({ backgroundColor: color });
  };

  getRoutes = () => {
    usuario_api.getCodigoFuncionalidadesUsuario().then(result => {      
      if (result.status === 200) {
        
        let _routes = []; // Carrega as rotas de navegação interna
        let _routesSidebar = []; // Carrega o itens do menu

        routes.map((prop, key) => {          
          if (!prop.submenus) {            
            if (prop.codigoFuncionalidade == null || result.data.filter(f => f == prop.codigoFuncionalidade).length > 0) {
              _routesSidebar.push(prop);
              _routes.push({
                layout: prop.layout,
                path: prop.path,
                component: prop.component,
                name: prop.name,
                icon: prop.icon
              })
            }
          }
          else {
            let _submenus = prop.submenus.filter(f => result.data.filter(y => y == f.codigoFuncionalidade).length > 0)
            if (_submenus.length > 0) {
              let _menu = prop;
              _menu.submenus = _submenus;
              _routesSidebar.push(_menu);
            }

            prop.submenus.map((subprop, subkey) => {
              if (subprop.codigoFuncionalidade == null || result.data.filter(f => f == subprop.codigoFuncionalidade).length > 0) {
                _routes.push({
                  layout: prop.layout,
                  path: subprop.path,
                  component: subprop.component,
                  name: subprop.name,
                  icon: subprop.icon
                })
              }
            })
          }
        })        
        this.setState({ routes: _routes, routesSidebar: _routesSidebar });
      }
    });
  }

  render() {
    return (
      <div>
        <div className="wrapper">
          {this.state.routes != null &&
            <Sidebar
              {...this.props}
              routes={this.state.routesSidebar}
              bgColor={this.state.backgroundColor}
              activeColor={this.state.activeColor}
            />
          }
          <div className="main-panel" ref={this.mainPanel}>
            {this.state.routes != null &&
              <Navbar {...this.props} routes={this.state.routes} />
            }
            <Switch>
              {this.state.routes && this.state.routes.map((prop, key) => {
                return (
                  <Route
                    path={prop.layout + prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
            <Footer fluid />
          </div>
        </div>
      </div>
    );
  }
}

export default Admin;
